import React, { useEffect, useState } from 'react';
import AdminShell from '../components/AdminShell';
import { api, formatApiError } from '../lib/api';

const AdminSettings = () => {
  const [s, setS] = useState(null);
  const [draft, setDraft] = useState('');
  const [year, setYear] = useState('');
  const [err, setErr] = useState('');
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    api.get('/admin/settings').then((r) => {
      setS(r.data); setDraft(r.data.payment_instructions || ''); setYear(r.data.academic_year || 2027);
    });
  }, []);

  const save = async () => {
    setErr(''); setSaved(false);
    try {
      await api.patch('/admin/settings', { payment_instructions: draft, academic_year: Number(year) });
      setSaved(true); setTimeout(() => setSaved(false), 2000);
    } catch (e) { setErr(formatApiError(e)); }
  };

  return (
    <AdminShell title="Settings">
      {!s ? <p>Loading…</p> : (
        <div className="max-w-2xl bg-white rounded-2xl border border-black/5 p-6" data-testid="settings-card">
          <label className="block mb-5">
            <span className="text-xs font-semibold text-[#4B5563] uppercase tracking-wider block mb-1.5">Current academic year</span>
            <input className="apc-input" type="number" value={year} onChange={(e) => setYear(e.target.value)} data-testid="settings-year"/>
          </label>
          <label className="block mb-5">
            <span className="text-xs font-semibold text-[#4B5563] uppercase tracking-wider block mb-1.5">Payment instructions (shown to parents after registration)</span>
            <textarea rows={8} className="apc-input" value={draft} onChange={(e) => setDraft(e.target.value)} data-testid="settings-instructions"/>
          </label>
          {err && <p className="text-sm text-red-600 mb-3">{err}</p>}
          {saved && <p className="text-sm text-[#1F6F4A] mb-3" data-testid="settings-saved">Saved ✓</p>}
          <button onClick={save} className="btn-pill btn-primary" data-testid="settings-save">Save settings</button>
        </div>
      )}
      <style>{`.apc-input { width:100%; padding:0.75rem 1rem; border-radius:12px; border:1px solid rgba(27,42,65,0.15); background:#fff; font-size:0.95rem; }`}</style>
    </AdminShell>
  );
};

export default AdminSettings;
